import type { EligibilityFormData } from '../types'
import { SelectionRadioOption } from './SelectionRadioOption'

type TrainingPreferencesSectionProps = {
  areTrainingModeOptionsDisabled?: boolean
  formData: EligibilityFormData
  isLaptopSelectionDisabled?: boolean
  isInPersonAvailable: boolean
  shouldShowLaptopQuestion: boolean
  onUpdateFormData: (data: Partial<EligibilityFormData>) => void
  onClearSelectionError: () => void
}

export function TrainingPreferencesSection({
  areTrainingModeOptionsDisabled = false,
  formData,
  isLaptopSelectionDisabled = false,
  isInPersonAvailable,
  shouldShowLaptopQuestion,
  onUpdateFormData,
  onClearSelectionError
}: TrainingPreferencesSectionProps) {
  if (!shouldShowLaptopQuestion) {
    return null
  }

  return (
    <>
      <div className="animate-fade-in-up" style={{ animationDelay: '280ms' }}>
        <p className="modal-heading__subtitle mb-3 text-left">
          How would you like to attend classroom theory training?
        </p>

        <div className="space-y-1.5">
          {isInPersonAvailable ? (
            <SelectionRadioOption
              name="trainingMode"
              checked={formData.trainingMode === 'in-person'}
              disabled={areTrainingModeOptionsDisabled}
              label="In Person"
              onChange={() => {
                onUpdateFormData({ trainingMode: 'in-person', hasLaptop: undefined })
                onClearSelectionError()
              }}
            />
          ) : null}

          <SelectionRadioOption
            name="trainingMode"
            checked={formData.trainingMode === 'remote'}
            disabled={areTrainingModeOptionsDisabled}
            label="Remote Learning"
            onChange={() => {
              onUpdateFormData({ trainingMode: 'remote' })
              onClearSelectionError()
            }}
          />
        </div>
      </div>

      {formData.trainingMode === 'remote' ? (
        <div className="animate-fade-in-up" style={{ animationDelay: '340ms' }}>
          <p className="modal-heading__subtitle mb-3 text-left">
            Do you have access to a Laptop with camera?
          </p>

          <div className="mb-3.5 space-y-1.5">
            <SelectionRadioOption
              name="hasLaptop"
              checked={formData.hasLaptop === true}
              disabled={isLaptopSelectionDisabled}
              label="Yes"
              onChange={() => {
                onUpdateFormData({ hasLaptop: true })
                onClearSelectionError()
              }}
            />

            <SelectionRadioOption
              name="hasLaptop"
              checked={formData.hasLaptop === false}
              disabled={isLaptopSelectionDisabled}
              label="No"
              onChange={() => {
                onUpdateFormData({ hasLaptop: false })
                onClearSelectionError()
              }}
            />
          </div>

          {formData.hasLaptop === false ? (
            <div className="rounded-2xl border border-[#f9e79f] bg-[#fef9e7] p-3.5 text-left">
              <p className="text-sm leading-relaxed text-gray-700">
                We are pleased to lend you a laptop for the remote classroom theory training. Your
                enrollment manager will reach out to you after you enroll.
              </p>
            </div>
          ) : null}
        </div>
      ) : null}
    </>
  )
}
